import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTRPCAPI, useTRPCClientAPI, useTRPCMutation } from '../../trpc/trpc';

export interface MembersSeeEarningsState {
  setEnabled: (enabled: boolean) => Promise<void>;
  isPending: boolean;
  error: unknown;
}

/**
 * `workspaces.setMembersSeeEarnings` (design your-intelligence e4). Only the owner calls it. The
 * server hides every money field from a member while it is off, so the screens read again after
 * a change.
 */
export function useMembersSeeEarnings(): MembersSeeEarningsState {
  const trpcAPI = useTRPCAPI();
  const trpcClient = useTRPCClientAPI();
  const queryClient = useQueryClient();
  const { mutateAsync, isPending, error } = useTRPCMutation({
    mutationFn: (enabled: boolean) => trpcClient.workspaces.setMembersSeeEarnings.mutate({ enabled }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: trpcAPI.workspaces.list.queryKey() });
    },
  });
  const setEnabled = useCallback(
    async (enabled: boolean) => {
      await mutateAsync(enabled);
    },
    [mutateAsync]
  );
  return { setEnabled, isPending, error };
}
